/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { AzureCsAccountKind } from 'src/core/stores/AzureCsAccountStore';
import { ServiceKey } from 'src/core/stores/AzureSessionStore';
import { AuthoringRegion } from 'src/core/types/regionTypes';

/**
 * A singleton global instance that houses
 * environment metadata.
 */
export class GlobalEnvironmentMetadata {
    public endpoint: string;

    public serviceKey: ServiceKey = { keyType: 'none', value: null, userRole: 'none', displayedUserRole: 'none' };

    public region: AuthoringRegion;

    public currentResourceKind: AzureCsAccountKind;

    private static _instance: GlobalEnvironmentMetadata;

    public static get instance(): GlobalEnvironmentMetadata {
        if (!GlobalEnvironmentMetadata._instance) {
            GlobalEnvironmentMetadata._instance = new GlobalEnvironmentMetadata();
        }

        return GlobalEnvironmentMetadata._instance;
    }
}
